// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__S58BO","fadeInOpacity":"Modal_fadeInOpacity__kJ63l","close":"Modal_close__ub3Tg","text":"Modal_text__ulD1s"};